import { Select } from "antd";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";
import { useState } from "react";

const CustomSelect = ({ onDropdownVisibleChange, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  useBodyScrollLock(isOpen);

  const handleVisibleChange = (visible) => {
    setIsOpen(visible);
    onDropdownVisibleChange?.(visible);
  };

  return (
    <Select
      {...props}
      open={isOpen}
      onDropdownVisibleChange={handleVisibleChange}
    />
  );
};

export default CustomSelect;
